/* global document */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var axios = require('axios');
var BaseStorage = require('../base-storage');

var _require = require('../utils/constants'),
    NOT_FOUND = _require.NOT_FOUND,
    SERVER_ERROR = _require.SERVER_ERROR;

function getCookieValue(name) {
  if (typeof document === 'undefined') {
    return '';
  } else {
    return (document.cookie.match(name + '=([^;]*)') || ['']).pop();
  }
}

function getUserId() {
  var wixClient = getCookieValue('wixClient').split('|');
  return wixClient[6] || getCookieValue('_wixCIDX');
}

var WixStorageStrategy = function (_BaseStorage) {
  _inherits(WixStorageStrategy, _BaseStorage);

  function WixStorageStrategy() {
    _classCallCheck(this, WixStorageStrategy);

    return _possibleConstructorReturn(this, (WixStorageStrategy.__proto__ || Object.getPrototypeOf(WixStorageStrategy)).apply(this, arguments));
  }

  _createClass(WixStorageStrategy, [{
    key: 'extendScope',
    value: function extendScope(scope) {
      scope = typeof scope === 'string' ? { siteId: scope } : scope;
      return Object.assign({ userId: getUserId() }, scope);
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key,
        blob: value
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      if (options.expiration) {
        payload.TTLInDays = Math.ceil(options.expiration / (60 * 60 * 24));
      }
      return axios.post('/_api/wix-user-preferences-webapp/set', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      return axios.post('/_api/wix-user-preferences-webapp/delete', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefForSite' : 'getVolatilePrefForKey';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId, key].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data[key];
      }).catch(function (err) {
        throw err.response.status === 404 ? NOT_FOUND : SERVER_ERROR;
      });
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefsForSite' : 'getVolatilePrefs';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }]);

  return WixStorageStrategy;
}(BaseStorage);

module.exports = WixStorageStrategy;